__webpack_require__.p = "/stringer_online_text_editor/";